import React from 'react';
import { Link } from 'react-router-dom';

const HomeImageGeneratorSection = () => {
     return (
          <section className="home-image-generator-section">
               <div className="__container">
                    <div className="image-generator-shell">
                         <div className="left-content">
                              <span className="mini-badge">NEW TOOL</span>

                              <h2>
                                   Free AI Image Generator for
                                   <span> Stunning Visuals in Seconds</span>
                              </h2>

                              <p>
                                   Turn simple text prompts into high-quality AI images with
                                   HeyPrompt. Create realistic portraits, cinematic scenes,
                                   anime art, product visuals, social media creatives, and
                                   marketing graphics using one powerful image generation tool.
                              </p>

                              <div className="feature-points">
                                   <span>Text to Image</span>
                                   <span>Free & Premium Prompts</span>
                                   <span>Fast Generation</span>
                                   <span>Save Your Creations</span>
                              </div>

                              <div className="action-group">
                                   <Link to="/ai-image-generator" className="primary-btn">
                                        Generate AI Images
                                   </Link>

                                   <Link to="/category/chatgpt-prompts" className="secondary-btn">
                                        Explore Prompts
                                   </Link>
                              </div>
                         </div>

                         <div className="right-visual">
                              <div className="visual-card main-card">
                                   <div className="card-top">
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                        <span className="dot"></span>
                                   </div>

                                   <div className="prompt-box">
                                        <span className="label">Prompt</span>
                                        <p>
                                             Ultra realistic cinematic portrait of a woman walking
                                             in neon rain, dramatic lighting, editorial fashion,
                                             highly detailed...
                                        </p>
                                   </div>

                                   <div className="preview-grid">
                                        <div className="preview-item item-one"></div>
                                        <div className="preview-item item-two"></div>
                                        <div className="preview-item item-three"></div>
                                        <div className="preview-item item-four"></div>
                                   </div>
                              </div>

                              <div className="floating-tag top-tag">AI Image Generator</div>
                              <div className="floating-tag bottom-tag">Photorealistic • Anime • Art</div>
                         </div>
                    </div>
               </div>
          </section>
     );
};

export default HomeImageGeneratorSection;